module.exports = __webpack_public_path__ + "img/Animales-INGE-V6-DUO.8033773e.png";